export const projectsInitialState = {
  projects: null,
  projectsIsLoading: true,
  currentProject: null,
  currentProjectIsLoading: true,
  versions: null,
  versionsIsLoading: true,
  pagination: null,
};
